import { SvgExclamationCircle } from '@egw/assets'
import { type DefaultProps } from '@egw/components'
import { twMerge } from 'tailwind-merge'
import cx from 'classnames'
import { type FC } from 'react'
import { useTranslation } from '@egw/i18n'

export interface TotalDistributionProps extends DefaultProps {
  total: number
  isTotalError: boolean
}

export const TotalDistribution: FC<TotalDistributionProps> = ({
  // Common default properties for each component
  className,
  id,
  testId,
  ariaLabel,
  total,
  isTotalError,
}) => {
  const { t } = useTranslation('features-enrollment')
  // Component base class names. Can be overriden by className property.
  const baseClass = cx('w-full flex flex-col gap-2')

  // Final class names
  const finalClasses = twMerge(baseClass, className)
  return (
    <div
      className={finalClasses}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
      aria-hidden="true"
    >
      <div className="flex justify-between">
        <div className="typo-primary-md-semibold" data-testid="total-distribution-text">
          {t('common.total_distribution')}
        </div>
        <div
          className={cx('typo-primary-md-bold', {
            'text-text-error': isTotalError,
          })}
          data-testid="total-distribution-percentage"
        >
          {total}%
        </div>
      </div>
      {isTotalError ? (
        <div
          className="bg-[#ffeaea] typo-primary-sm-regular text-text-error p-2xs rounded flex items-center gap-2 mb-md"
          data-testid="total-distribution-error"
        >
          <SvgExclamationCircle fill="#c82320" />
          {t('common.total_distribution_message')}
        </div>
      ) : null}
    </div>
  )
}
